import { CircularProgress, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PropertyCombination from "common/components/chartNivo/pieChart-with-legends/propertyCombination";
import { useVideoTooltip } from "common/customHook/useVideoTootip";
import { memo } from "react";
import { useSelector } from "react-redux";
import Description from "../description";
import { superiorAnalysis } from "../nlg/nlg";
import { useTheme, useMediaQuery } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  tooltip: {
    maxWidth: 250,
    fontSize: 12,
    padding: 5,
  },
}));
const Pie2Box = memo(({ tip }) => {
  const [setvideo, htmlCodeVideo] = useVideoTooltip();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const classes = useStyles();

  const superiorReducer = useSelector(
    (state) => state.select_superior_industries_reducer,
  );

  const loadingReducer = useSelector((state) => state.loading);

  const analysis = superiorAnalysis(superiorReducer.data);

  return (
    <>
      <div
        className="flex justify-between items-center"
        style={{ width: "max-content" }}
      >
        <h1 className="pr-3 mb-3 mt-2 mx-2">گردش صنایع</h1>
        <Tooltip
          title={<p className="p-2 m-0">{tip}</p>}
          placement={isMobile ? "bottom" : "left"}
          arrow
          classes={{ tooltip: classes.tooltip }}
          enterTouchDelay={1}
        >
          <img src="/media/image/Group 12485.png" alt="" />
        </Tooltip>
      </div>

      <div className="grid grid-cols-12">
        <div className="col-span-12 lg:col-span-4">
          <div className="text-sm text-gray-700 p-5">
            نمودار روبرو، مجموع گردش مالی شما در صنایع مختلف را نمایش می‌دهد.
          </div>
          <Description analysis={analysis} />
        </div>
        <div className="col-span-12 lg:col-span-8">
          {loadingReducer.loading ? (
            <div className="h-full w-full flex justify-center items-center">
              <CircularProgress />
            </div>
          ) : (
            <div className="h-[500px] md:h-[400px]">
              <PropertyCombination data={superiorReducer} pie2Reports />
            </div>
          )}
        </div>
      </div>
    </>
  );
});

export default Pie2Box;
